import DescriptionSection from './DescriptionSection';
import {AccessBtnComponent} from '../access-btn.component';

const ServicesSection = () => {
    return (
            <DescriptionSection
                showService
                title={'My services'}
                children={  <AccessBtnComponent text="Contact Now"
                                                                            className="px-20 md:px-24 py-8 border-2 border-pink-700 rounded-xl text-white relative mt-6 text-lg bg-pink-600 font-semibold"/>}/>
    )
}
export default ServicesSection;
